
import { defineComponent, ref } from 'vue'
import { useStore } from '@/store/index'
import { toArray } from '@/utils/array'

import LayoutAuthSidebarContentMenu from '@/components/LayoutAuthSidebarContentMenu.vue'

export default defineComponent({
  components: { LayoutAuthSidebarContentMenu },
  setup() {
    const menuCategory = ref([1, 2, 3])
    const store = useStore()

    return {
      menuCategory,
      store,
      toArray
    }
  },
})
